import { Flex } from '@/components/base';
import { MainText } from '@/components/Typography/NamedTypo';
import Label from '@/features/Feedback/field/Tag/Label';
import useCategoryMap from '@/hooks/domain/useCategoryMap';
import useCellEllipsisAsCount from '@/hooks/domain/useCellEllipsisAsCount';
import useColumnConfigStore from '@/stores/DataTable/ColumnConfigStore';
import type { CATEGORY_TYPE } from '@/types/categoryConst';

type Props = {
  classification?: CATEGORY_TYPE[];
};

const CategoryOnRow = (props: Props) => {
  const currentCategoryMap = useCategoryMap();
  const { feedback_view } = useColumnConfigStore(
    (state) => state.columnConfigs,
  );

  const columnWidth = feedback_view.find((c) => c.name === 'category')?.width;

  const { ref, numTagsToShow } = useCellEllipsisAsCount({
    length: props.classification?.length || 0,
    columnWidth,
  });

  return (
    <Flex ref={ref} w="nowrap">
      {props.classification?.slice(0, numTagsToShow).map((key) => {
        const category = currentCategoryMap[key];
        if (!category) return null;
        return (
          <Label
            key={key}
            text={category.name}
            customColor={category.color}
            themeColor={0}
            isSelected={false}
            withoutBorder
          />
        );
      })}

      {props.classification && props.classification.length > numTagsToShow && (
        <MainText dim>+{props.classification.length - numTagsToShow}</MainText>
      )}
    </Flex>
  );
};

export default CategoryOnRow;
